import { combineReducers } from 'redux';

import {
  FETCH_FILTERED_ENTITY_SUCCESS,
  DELETE_ENTITY_SINGLE_SUCCESS,
  FETCH_FILTERED_ENTITY_FAILURE,
} from '@store/entity/actions';

import { RESET_ENTITY_FILTERS } from '@store/filtered/actions';

export const createReducerForEntity = (entityName) => {
  const initialPaginationState = {
    result: [],
    total: 0,
    filters: {},
    pagination: {},
  };

  return (state = initialPaginationState, action) => {
    const { payload } = action;
    switch (action.type) {
      case FETCH_FILTERED_ENTITY_SUCCESS: {
        if (payload.pagination[entityName]) {
          return {
            ...payload.pagination[entityName],
            filters: payload.filters,
            result: payload.data.result[entityName],
          };
        }
        return state;
      }
      case FETCH_FILTERED_ENTITY_FAILURE: {
        if (action.entityName === entityName) {
          return {
            ...state,
            filters: payload.filters,
          };
        }
        return state;
      }
      case DELETE_ENTITY_SINGLE_SUCCESS: {
        if (payload[entityName] && payload[entityName].id) {
          return {
            ...state,
            total: state.total - 1,
            result: state.result.filter((id) => id !== payload[entityName].id),
          };
        }
        return state;
      }
      case RESET_ENTITY_FILTERS: {
        return {
          ...state,
          filters: {},
        };
      }
      default: {
        return state;
      }
    }
  };
};

export default combineReducers({
  properties: createReducerForEntity('properties'),
  categories: createReducerForEntity('categories'),
  users: createReducerForEntity('users'),
  products: createReducerForEntity('products'),
});
